import { css } from '@inter-ikea-kompis/web-component';

import SheetAnimationNameEnum from '../../enums/CountdownBannerAnimationNameEnum.js';
import type ICountdownBannerStyleOptions from '../../types/ICountdownBannerStyleOptions.js';

export default class CountdownBannerStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object.
	 * @param options.isVisible "true" if visible.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: ICountdownBannerStyleOptions): string {
		const { spacing, color, motion } = options.theme;
		return css`
			:host {
				position: fixed;
				display: flex;
				flex-direction: column;
				left: 0;
				right: 0;
				bottom: 0;
				top: 0;
				transition-duration: ${options.theme.motion.duration.medium};
				transition-property: bottom, top;
				pointer-events: none;
			}

			.container {
				min-height: ${spacing.space750 / 16}rem;
				pointer-events: ${options.isAnimating ? 'none' : 'auto'};
				overflow: hidden;
				background-color: ${color.neutral.white};
				display: flex;
				flex-direction: column;
				animation-name: ${options.isVisible
					? SheetAnimationNameEnum.opening
					: SheetAnimationNameEnum.closing};
				animation-duration: ${options.isVisible ? motion.duration.medium : motion.duration.small};
				animation-fill-mode: both;
				animation-timing-function: ${options.isVisible ? motion.ease.enter : motion.ease.exit};
			}

			.countdownBannerHeader {
				color: ${color.text.dark};
			}

			kompis-sheet-backdrop {
				pointer-events: auto;
			}

			kompis-countdown {
				margin-inline-end: ${spacing.space150 / 16}rem;
			}

			.countdownBannerGalleryButton {
				margin-inline-end: ${spacing.space75 / 16}rem;
			}

			.rightContent {
				display: flex;
				margin-inline-start: auto;
				align-items: center;
			}

			.bannerContainer {
				display: flex;
				align-items: center;
				flex-grow: 1;
				pointer-events: ${options.isVisible ? 'auto' : 'none'};
				padding-right: ${spacing.space400 / 16}rem;
				padding-left: ${spacing.space400 / 16}rem;
			}

			overlayContainer {
				width: 100%;
				height: 80%;
				opacity: 0.5;
			}

			@keyframes closing {
				from {
					transform: translateY(0);
				}
				to {
					transform: translateY(-100%);
				}
			}
			@keyframes opening {
				from {
					transform: translateY(-100%);
				}
				to {
					transform: translateY(0);
				}
			}
		`;
	}
}
